import script from "./ChangeBillingPeriodPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeBillingPeriodPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeBillingPeriodPopup.vue?vue&type=style&index=0&id=678b5f95&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678b5f95"]])

export default __exports__